import { useEffect, useState } from "react";
import { fetchTableDatumAPI } from "../../api/infrastructure/table-data.api";
import type { TableData } from "../../api/infrastructure/table-data.formatter";
import { apiRequestWrapper } from "../../api/shared/http-client";
import { showToast } from "../shared/global-tools/toast-system";

export default function useGetTableDatum({
  referenceId,
  tableId,
  datumId,
  preloadData = true,
}: {
  referenceId?: number;
  tableId?: number;
  datumId?: number;
  preloadData?: boolean;
} = {}) {
  const [tableDatum, setTableDatum] = useState<TableData>();
  const [loading, setLoading] = useState<boolean>(false);

  const fetchTableDatum = async (refId: number, tblId: number, dtmId: number) => {
    setLoading(true);
    await apiRequestWrapper(async () => {
      try {
        const result = await fetchTableDatumAPI({
          referenceId: refId,
          tableId: tblId,
          datumId: dtmId,
        });
        setTableDatum(result);
      } catch (error) {
        console.error("Error fetching table datum:", error);
        showToast("Error fetching table datum", { severity: "error" });
      } finally {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    if (!preloadData) return;
    if (referenceId === undefined || tableId === undefined || datumId === undefined) return;
    fetchTableDatum(referenceId, tableId, datumId);
  }, [referenceId, tableId, datumId, preloadData]);

  return {
    tableDatum,
    loadingTableDatum: loading,
    fetchTableDatum,
    setTableDatum,
  };
}
